import React, { FC, useEffect, useState } from 'react'

import { EyeLineIcon, EyeSlashLineIcon } from '@inno-ui/icons'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import { InputActionButton } from '../InputActionButton'
import styles from './AuthInput.module.scss'
import { AuthInputProps } from './AuthInput.types'

export const AuthInput: FC<AuthInputProps> = ({
  className,
  inputClassName,
  actionButton,
  error,
  type,
  showTogglePassword = false,
  value,
  ...props
}) => {
  const { t } = useTranslation('auth', { keyPrefix: 'password_aria_label' })
  const { show: showActionButton, ...actionButtonProps } = actionButton ?? {}
  const hasError = Boolean(error)
  const [showPassword, setShowPassword] = useState(false)
  const isPasswordType = type === 'password'
  const hasValue = Boolean(value && String(value).trim().length > 0)
  const showPasswordToggle = showTogglePassword && isPasswordType && hasValue
  const inputType = showPasswordToggle && showPassword ? 'text' : type
  const showActionButtonWrapper =
    Boolean(showActionButton) || showPasswordToggle
  const PasswordIcon = showPassword ? EyeSlashLineIcon : EyeLineIcon

  useEffect(() => {
    if (!hasValue) {
      setShowPassword(false)
    }
  }, [hasValue])

  return (
    <div className={cn(styles.wrapper, className)}>
      <div
        className={cn(styles.inputWrapper, {
          [styles.hasError]: hasError
        })}
      >
        <input
          {...props}
          type={inputType}
          value={value}
          className={cn(styles.authInput, inputClassName, {
            [styles.hasActionButton]: showActionButtonWrapper
          })}
        />
        <InputActionButton
          show={showPasswordToggle}
          onClick={() => setShowPassword(!showPassword)}
          icon={PasswordIcon}
          aria-label={showPassword ? t('hide_password') : t('show_password')}
        />
        <InputActionButton
          show={Boolean(showActionButton)}
          {...actionButtonProps}
        />
      </div>
      {error && <div className={styles.error}>{error}</div>}
    </div>
  )
}
